// @flow strict

import * as React from 'react'
import PaidSectionWrapper from '../PaidSectionWrapper'
import styles from './FeatureGrid.module.scss'
import { AccessibilityText } from '@mondough/public-web-components'
import placeholder from '../../../static/images/icons/placeholder.png'
type Feature = {
  title: string,
  description: string,
  iconHref: string,
}

const FeatureGrid = ({ features }: { features: Feature[] }) => (
  <PaidSectionWrapper
    className={styles.section}
    contentClassName={styles.content}
  >
    {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
    <AccessibilityText as={<h2 />}>Features</AccessibilityText>
    <ul className={styles.list}>
      {features.map(({ title, description, iconHref }) => (
        <li key={title} className={styles.item}>
          <img src={iconHref || placeholder} alt="" className={styles.icon} />
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </li>
      ))}
    </ul>
  </PaidSectionWrapper>
)

export default FeatureGrid
